import gql from 'graphql-tag';

export const QUERY_GET_QUEST_STATUS = gql`
  query questStatus {
    questStatus {
      localeInfo
      questStatus {
        requestId
        transactionId
        patronAccountNumber
        preferredPropValidFrom
        preferredPropValidTo
        UTCValidFrom
        UTCValidTo
        isComplete
        completionDate
        UTCCompletionDate
        utcAbortionDate
        abortionDate
        quest {
          id
          prizeDetails {
            name
            url
            description
          }
          prizes {
            prizes {
              id
              name
              category
            }
          }
          leaderboardEnabled
          leaderboardDescription
        }
        missionStatuses {
          id
          goal
          progress
          progressText
          mission {
            id
            description
            icons {
              url
              alt
            }
          }
        }
      }
    }
  }
`;

export const SUBSCRIPTION_QUEST_PROGRESS = gql`
  subscription QuestProgressUpdate {
    questProgressUpdate {
      progressUpdate {
        localeInfo
        questStatus {
          transactionId
          patronAccountNumber
          preferredPropValidFrom
          preferredPropValidTo
          UTCValidFrom
          UTCValidTo
          isComplete
          completionDate
          UTCCompletionDate
          utcAbortionDate
          abortionDate
          quest {
            id
            prizeDetails {
              name
              url
              description
            }
            prizes {
              prizes {
                id
                name
                category
              }
            }
            leaderboardEnabled
            leaderboardDescription
          }
          missionStatuses {
            id
            goal
            progress
            progressText
            mission {
              id
              description
              icons {
                url
                alt
              }
            }
          }
        }
      }
    }
  }
`;

export const SUBSCRIPTION_ONLINE_MISSION_USER_EVENTS = gql`
  subscription onlineMissionUserEvents {
    onlineMissionUserEvents {
      missionId
      questId
      progress
      progressText
    }
  }
`;
